import React, { useState } from "react";
// import "./App.css";
import BookedReports from "./BookedReports";
import BlockedReports from "./BlockedReports";
import CancelledReports from "./CancelledReports";
import Header from "./Header";

const App = () => {
  const [activeTab, setActiveTab] = useState("booked");

  // Render content based on the active tab
  const renderContent = () => {
    switch (activeTab) {
      case "booked":
        return <BookedReports />;
      case "blocked":
        return <BlockedReports />;
      case "cancelled":
        return <CancelledReports />;
      default:
        return <BookedReports />;
    }
  };

  return (
    <div >
     <Header/>

      {/* Tabs Section */}
      <nav className="tabs px-5 pt-3">
        <button
          className={`tab mx-2 ${activeTab === "booked" ? "active" : ""}`}
          onClick={() => setActiveTab("booked")}
        >
          Booked
        </button>
        <button
          className={`tab mx-2 ${activeTab === "blocked" ? "active" : ""}`}
          onClick={() => setActiveTab("blocked")}
        >
          Blocked
        </button>
        <button
          className={`tab mx-2 ${activeTab === "cancelled" ? "active" : ""}`}
          onClick={() => setActiveTab("cancelled")}
        >
          Cancelled
        </button>
      </nav>

      {/* Dynamic Content */}
      <main className="content">{renderContent()}</main>
    </div>
  );
};

export default App;
